import { render } from "./ChartView.vue?vue&type=template&id=b6b23b1c"
import script from "./ChartView.vue?vue&type=script&lang=js"
export * from "./ChartView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__